export default {
  products: [],
  productSimilar: [],
  product: {},
  loading: false,
};
